import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
export const getArticleByUUIDKey = (uuid) => QueryClientHelper.makeQueryKey('/rest/article/{article_uuid_or_slug}', {
    uuid,
});
export const getArticleBySlugKey = (slug) => QueryClientHelper.makeQueryKey('/rest/article/{article_uuid_or_slug}', {
    slug,
});
export const getArticleResultsByFEContextKey = (frontendContextUUID) => QueryClientHelper.makeQueryKey('articleResults', {
    frontend_context_uuid: frontendContextUUID,
});
export const getArticleSlugKey = (slug) => QueryClientHelper.makeQueryKey('article-slug', slug);
//# sourceMappingURL=articleKeys.js.map